/* eslint-disable camelcase */
import {identifyUser, trackLogin} from '../segment'
function NotFoundError(message) {
  const error = new Error(message)
  error.status = 404
  return error
}

NotFoundError.prototype = Object.create(Error.prototype)
;(function module() {
  angular.module('app.ui.form.ctrls').controller('SignInController', [
    'api',
    'usSpinnerService',
    'userService',
    '$window',
    'LogInApi',
    '$scope',
    function controller(
      api,
      usSpinnerService,
      userService,
      $window,
      LogInApi,
      $scope
    ) {
      require('../../olark-chat-box.js')
      let vm = this

      vm.idToken = ''

      vm.startcounter = 0
      vm.spinneractive = false

      vm.startSpin = () => {
        if (!vm.spinneractive) {
          usSpinnerService.spin('spinner-1')
          vm.spinneractive = true
          return vm.startcounter++
        }
      }

      vm.stopSpin = () => {
        if (vm.spinneractive) {
          usSpinnerService.stop('spinner-1')
          vm.spinneractive = false
        }
      }

      vm.user = {}
      vm.showOnError = false
      vm.alertMsg = ' '
      vm.showClass = ''
      vm.hideDropDown = () => {
        vm.showClass = ''
      }

      vm.showDropDown = () => {
        if (vm.showClass === '') {
          vm.showClass = 'show'
        } else {
          vm.showClass = ''
        }
      }

      vm.changeStatus = status => {
        console.debug('changeStatus', status)
        if (typeof status === 'string') vm.alertMsg = status
        else if (status === 404) {
          vm.alertMsg = 'Invalid username/password entered. Please try again.'
        } else if (status === 500) {
          vm.alertMsg =
            'Could not connect to the server. Please try again later.'
        } else {
          vm.alertMsg = 'An error has occurred. Please try the action again.'
        }

        vm.showOnError = true
      }

      vm.AuthenticateUser = async () => {
        console.debug('AuthenticateUser: start')
        vm.startSpin()

        try {
          const loginResponse = await LogInApi.logIn({
            email: vm.user.email,
            password: vm.user.password,
          })

          if (!loginResponse) {
            throw new NotFoundError('No user found')
          }

          const {data} = loginResponse

          console.debug('AuthenticateUser: got login response')
          vm.idToken = data.tokenResponse.id_token
          api.startSession(data.tokenResponse)
          vm.stopSpin()
          const user = await userService.setUser(data.user)
          $window.localStorage.setItem('signIn', Date.now())
          try {
            const user = identifyUser()
            trackLogin(user)
          } catch (error) {
            console.error('AuthenticateUser: tracking failed', error)
          }

          $window.location.href = user.defaultRoute
        } catch (error) {
          vm.stopSpin()
          if (error && error.data && error.data.error_description) {
            console.error(
              `AuthenticateUser: failed`,
              error,
              'description',
              error.data.error_description
            )
            vm.changeStatus(error.data.error_description)
          } else if (error && error.status) {
            console.warn(
              `AuthenticateUser: changing status - ${error.status}`,
              error
            )
            vm.changeStatus(error.status)
          } else {
            console.warn('AuthenticateUser: unknown error', error)
            vm.changeStatus(error)
          }
        }

        $scope.$apply()
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/sign-in/sign-in.ctrl.js